import {
    Button,
    Dialog,
    DialogActions,
    DialogContent,
    DialogTitle,
    Typography
  } from "@material-ui/core";
  import React from "react";
  import { store } from "./helpers";
  import { useSelector } from "react-redux";
  import  Close from "@material-ui/icons/Close";
  import { makeStyles } from "@material-ui/core/styles";
  import { Skeleton } from "@material-ui/lab";
  import { useTranslation } from "react-i18next";
  const useStyles = makeStyles((theme) => ({
    dialogTitle: {
      background: theme.palette.ePrimary?.base,
      color: theme.palette.eWhite?.base,
      padding: "10px 12px 10px 12px"
    },
    titleFont:{
      fontSize:"1rem",
      marginRight : '5rem'
    },
    dialogContent: {
      padding: "3% 3%"
    },
    buttonStyle: {
      backgroundColor:theme.palette.ePrimary?.base,
      color:theme.palette.eWhite?.base,
      borderRadius:30,
      fontSize:"0.875rem",
      '&:hover': {
        backgroundColor: theme.palette.ePrimary?.hover,
      },
      padding: "1% 8%",
    },
    crossButton:{
      color: theme.palette.eWhite?.base,
      position: 'absolute',
      right: 0,
      top: 10,
      justifyContent: "end",
    },
  }));
  export const UpdatePrompt = () => {
    console.log("checking if the sw is working or not by chaning the code")
    const style = useStyles();
    const { t: labels, ready: labelReady } = useTranslation("label-E_APP_UPDATE") 
    const openDialog = useSelector((state) => state?.appUpdate?.openDialog);
    const handleOkClick = () => {
      store.dispatch({ type: "CLOSE_DIALOG" });
      window.location.reload();
    };
    const handleClose = () => {
      store.dispatch({ type: "CLOSE_DIALOG" });
    };
    return (
      <>
        <Dialog
          open={openDialog}
          onClose={handleClose}
          disableBackdropClick
        >
          <DialogTitle id="alert-dialog-title" className={style.dialogTitle}>
            <Typography variant="subtitle1" align="left">
              <b>{labelReady ? labels("E_APP_UPDATE_TITLE") : <Skeleton />}</b>
            </Typography>
            <Button startIcon={<Close />} onClick={handleClose} className={style.crossButton}></Button>
          </DialogTitle>
          <DialogContent className={style.dialogContent}>
            {labelReady ? labels("E_APP_UPDATE_DESCRIPTION") : <Skeleton />}
          </DialogContent>
          <DialogActions>
            <Button
              onClick={handleOkClick}
              variant="contained"
              size="small"
              className={style.buttonStyle}
              align="right"
            >
              {labelReady ? labels("E_APP_UPDATE_ACTION_BUTTON") : <Skeleton />} 
            </Button>
          </DialogActions>
        </Dialog>
      </>
    );
  };